import { createStore } from 'vuex'
import session from './modules/session.js'
import memoize from './modules/memoize.js'
import { isObject } from '../utils/helpers'

const store = createStore({
  actions: {}, // This is here just to make things work
  getters: {}, // This is here just to make things work
  mutations: {}, // This is here just to make things work
  state: {}, // This is here just to make things work
  modules: {
    session,
    memoize,
  },
})

/**
 * @param {Object|Undefined} agency
 * @returns {Object}
 * @description Returns a user object thats given, else falls back to the store
 */
export const agencyObj = (agency) =>
  isObject(agency) ? agency : store.getters['session/agency']

/**
 * @param {Object|Undefined} account
 * @returns {Object}
 * @description Returns a user object thats given, else falls back to the store
 */
export const accountObj = (account) =>
  isObject(account) ? account : store.getters['session/account']

/**
 * @param {Object|Undefined} user
 * @returns {Object}
 * @description Returns a user object thats given, else falls back to the store
 */
export const userObj = (user) =>
  isObject(user) ? user : store.getters['session/user']

/**
 * @param {Object|Undefined} branding
 * @returns Returns the branding object thats given, else falls back
 * to the store
 */
export const brandingObj = (branding) =>
  isObject(branding) ? branding : store.getters['session/branding']

/**
 * @param {Object|Undefined} entityBranding
 * @returns Returns the entityBranding object thats given, else falls back
 * to the store
 */
export const entityBrandingObj = (entityBranding) =>
  isObject(entityBranding)
    ? entityBranding
    : store.getters['session/entityBranding']

/**
 * @param {Object|Undefined} entityBranding
 * @returns Returns the temp session data object thats given, else falls back
 * to the store
 */
export const tempDataObj = (tempData) =>
  isObject(tempData) ? tempData : store.getters['session/tempData']

/**
 * @param {Object|Undefined} entityBranding
 * @returns Returns the drilldownState data object thats given, else falls back
 * to the store
 */
export const drilldownStateObj = (drilldownState) =>
  isObject(drilldownState) ? drilldownState : store.getters['session/drilldownState']

export default store
